import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConsent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 141,
	height: 140,
	viewBox: "0 0 141 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 70.5,
			cy: 70,
			r: 70,
			fill: "#D61E5C",
			fillOpacity: .06
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71 40.6666L47 51.3333V67.3333C47 82.1333 57.24 95.9733 71 99.3333C84.76 95.9733 95 82.1333 95 67.3333V51.3333L71 40.6666ZM65.6667 83.3333L55 72.6666L58.76 68.9066L65.6667 75.7866L83.24 58.2133L87 62L65.6667 83.3333Z",
			fill: "#253746"
		})
	]
});
export default SvgConsent;
